module.exports = __webpack_public_path__ + "img/hzm-bottom.18b4d6b3.png";